export default {
    methods: {
        checkIIN(iin) {
            return this.checkIdentifierKz(iin, 'ИИН неверный');
        },
        checkBIN(bin) {
            return this.checkIdentifierKz(bin, 'БИН неверный');
        },
        checkRnn(rnn) {
            if (!rnn) return true;
            if (rnn.length != 12) return this.$t('Введите 12 цифр');
            if (!/[0-9]{12}/.test(rnn)) return this.$t('РНН неверный');
            return true;
        },
        checkIdentifierKz(id, notValidMessage) {
            if (!id) return false;
            if (id.length != 12) return this.$t('Введите 12 цифр');
            if (!/[0-9]{12}/.test(id)) return this.$t(notValidMessage);

            //Проверяем контрольный разряд
            var b1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            var b2 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
            var a = [];
            var controll = 0;
            for (let i = 0; i < 12; i++) {
                a[i] = parseInt(id.substring(i, i + 1));
                if (i < 11) controll += a[i] * b1[i];
            }
            controll = controll % 11;
            if (controll == 10) {
                controll = 0;
                for (var i = 0; i < 11; i++) controll += a[i] * b2[i];
                controll = controll % 11;
            }
            if (controll != a[11]) return this.$t(notValidMessage);
            return true;
        },
        required(val) {
            if (val) {
                return true;
            } else {
                return this.$t('Обязательное поле');
            }
        },
        dateValidation(val) {
            if (!val) {
                return true;
            } else {
                let year = Number(val.slice(0, 4));
                if (year < 1900) {
                    return 'Дата документа должна быть не ранее 1900 года';
                }
                return true;
            }
        },
        getFullPathByComponentName(name, id) {
            if (name === 'PlaceCardPage') {
                let props = this.$router.resolve({
                    name: name,
                    params: { record_id: id }
                });
                return props.href;
            } else {
                let props = this.$router.resolve({
                    name: name,
                    params: { id }
                });
                return props.href;
            }
        },
        checkCadastralNumber(val) {
            // if (val === undefined) {
            //   return true; // Когда страница только загрузилась, кадастровый номер ещё не загрузился из базы данных. Возвращаем true, чтобы валидация не ломалась из-за этого
            // }
            if (!val) {
                return 'Введите кадастровый номер';
            }
            let numbers = val.split(':');
            if (numbers[3]) {
                if (numbers[3].length >= 3) {
                    return true;
                } else {
                    return 'Неправильный кадастровый номер';
                }
            } else {
                return 'Неполный кадастровый номер';
            }
        },
        openLandsPage(id) {
            this.$router.push({
                name: 'PlaceCardPage',
                params: { record_id: id }
            });
        },
        getLandSpecialPurposes(purposes, specialPurposeData) {
            let arr = '';
            if (purposes) {
                for (let i = 0; i < purposes.length; i++) {
                    specialPurposeData.filter(item => {
                        if (item.record_id == purposes[i].special_purpose_rid) {
                            i == 0 ? (arr += item.ref_storage_data.Name) : (arr += ', ' + item.ref_storage_data.Name);
                        }
                    });
                }
            }
            return arr;
        }
    }

    // onlyPositiveNumbers(val) {
    //   if (val) {
    //     if (!iin) return false;
    //     val = parseFloat(val);
    //     if (val < 0) return "Число должно быть положительным";
    //     return true;
    //   }
    // }
};
